/**
 * Created by pandemio on 3/29/19.
 */
import React from 'react';
import 'react-bootstrap-table-next/dist/react-bootstrap-table2.min.css';
import {Col, Row, Button, Input} from 'reactstrap';
import LoaderFullWindow from '../loader-windows/loader-full-window';
/** Multiple Language imports **/
import {Translate} from "react-localize-redux";
/** End of Multiple Language imports **/
import ApiCalls from "../../custom-classes/api-calls";
import PaginationCustom from './pagination';
import DataTable from './datatable';
import 'react-dates/initialize';
import 'react-dates/lib/css/_datepicker.css';
import DatePicker from '../date-picker/date-picker-recent';
import moment from 'moment';

class ProfilesDataTable extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            subscriptionId : null,
            username: null,
            email: null,
            phone: null,
            firstName: null,
            lastName: null,
            status: null,
            planId: null,
            loading: false,
            roleId: 3,
            dateFrom: null,
            dateTo: null,
            createdDateFrom: null,
            createdDateTo: null,
            createdAt: moment(),
            currentPage: 1,
            limiter: 10,
            totalPages: 1,
            headerOptions: [
                {key: "0", name: <Translate id="users-datatable.username"/>},
                {key: "1", name: <Translate id="users-datatable.first-name"/>},
                {key: "2", name: <Translate id="users-datatable.last-name"/>},
                {key: "3", name: <Translate id="users-datatable.last-session"/>}
            ],
            data: []
        };
        this.doSearch = this.doSearch.bind(this);
        this.convertDataToDataTable = this.convertDataToDataTable.bind(this);
        this.handlePageClick = this.handlePageClick.bind(this);
        this.handleRowClick = this.handleRowClick.bind(this);
        this.filter = this.filter.bind(this);
        this.handleUserIdChange = this.handleUserIdChange.bind(this);
        this.handleUsernameChange = this.handleUsernameChange.bind(this);
        this.handleFirstNameChange = this.handleFirstNameChange.bind(this);
        this.handleLastNameChange = this.handleLastNameChange.bind(this);
        this.handleEmailChange = this.handleEmailChange.bind(this);
        this.handleStatusChange = this.handleStatusChange.bind(this);
        this.handlePhoneChange = this.handlePhoneChange.bind(this);
        this.saveToDate = this.saveToDate.bind(this);
        this.saveFromDate = this.saveFromDate.bind(this);
        this.saveCreatedToDate = this.saveCreatedToDate.bind(this);
        this.saveCreatedFromDate = this.saveCreatedFromDate.bind(this);
    }

    componentWillReceiveProps(props){
        if(props.redoSearch)
            this.doSearch();
    }

    componentDidMount(){
        // Call data
        this.doSearch();
    }

    handleStatusChange(e){
        this.setState({
            status: e === '' ? null : e
        });
    }


    handleEmailChange(e){
        this.setState({
            email: e.target.value
        });
    }

    handlePhoneChange(e){
        this.setState({
            phone: e.target.value
        });
    }

    handleUserIdChange(e){
        this.setState({
            userId: e.target.value
        });
    }

    handleUsernameChange(e){
        this.setState({
            username: e.target.value
        });
    }

    handleFirstNameChange(e){
        this.setState({
            firstName: e.target.value
        });
    }

    handleLastNameChange(e){
        this.setState({
            lastName: e.target.value
        });
    }

    handlePageClick(e){
        this.setState({
            currentPage: e
        },()=>{
            this.doSearch();
        });
    }

    filter(){
        this.doSearch();
    }

    handleRowClick(e){
        this.setState({
            username: e.Username,
            firstName: e.GivenName,
            lastName: e.Surname
        });
        this.props.updateParent(e);
    }

    convertDataToDataTable(dataToConvert){

        this.setState({
            data: []
        },()=>{
            let newArray = [];

            for(let i=0; i < dataToConvert.length; i++)
            {
                newArray.push({
                    Username: dataToConvert[i].Username,
                    GivenName: dataToConvert[i].FullName.GivenName,
                    Surname: dataToConvert[i].FullName.Surname,
                    LastSession: dataToConvert[i].LastSession,
                    value: dataToConvert[i].UserId
                });
            }
            this.setState({
                data: newArray
            });
        });

    }

    /**
     * Call the results to display
     */
    doSearch() {
        this.setState({
            loading: true
        });

        let apiCall = ApiCalls.getProfiles(
            this.state.firstName,
            this.state.lastName,
            this.state.username,
            this.state.currentPage,
            this.state.limiter
        );

        apiCall.then((data)=> {
            this.setState({
                loading: false,
                totalPages: data.PageTotals,
                data: []
            },()=>{
                if(data.UserInfo !== null)
                    this.convertDataToDataTable(data.UserInfo);
            });
        });
    }

    saveFromDate = (field) => (newValue)=>{
        this.setState({dateFrom: newValue.date});
    };

    saveToDate = (field) => (newValue)=>{
        this.setState({dateTo: newValue.date});
    };

    saveCreatedFromDate = (field) => (newValue)=>{
        this.setState({createdDateFrom: newValue.date});
    };

    saveCreatedToDate = (field) => (newValue)=>{
        this.setState({createdDateTo: newValue.date});
    };


    // Render a generic modal. The body text should be sent in the text
    render() {
        return (
            <div>
                <Row>
                    <Col lg={{size: 6}} md={{size: 6}} sm={{size: 12}} xs={{size: 12}}>
                        <Row>
                            <Col lg={{size: 6}} md={{size: 6}} sm={{size: 6}} xs={{size: 6}}>
                                <Translate id="users-datatable.username"/>
                            </Col>
                            <Col lg={{size: 6}} md={{size: 6}} sm={{size: 6}} xs={{size: 6}}>
                                <Input type="text" value={this.state.username} onChange={this.handleUsernameChange} />
                            </Col>
                        </Row>
                    </Col>
                </Row>

                <Row>
                    <Col lg={{size: 6}} md={{size: 6}} sm={{size: 12}} xs={{size: 12}}>
                        <Row>
                            <Col lg={{size: 6}} md={{size: 6}} sm={{size: 6}} xs={{size: 6}}>
                                <Translate id="users-datatable.first-name"/>
                            </Col>
                            <Col lg={{size: 6}} md={{size: 6}} sm={{size: 6}} xs={{size: 6}}>
                                <Input type="text" value={this.state.firstName} onChange={this.handleFirstNameChange} />
                            </Col>
                        </Row>
                    </Col>
                    <Col lg={{size: 6}} md={{size: 6}} sm={{size: 12}} xs={{size: 12}}>
                        <Row>
                            <Col lg={{size: 6}} md={{size: 6}} sm={{size: 6}} xs={{size: 6}}>
                                <Translate id="users-datatable.last-name"/>
                            </Col>
                            <Col lg={{size: 6}} md={{size: 6}} sm={{size: 6}} xs={{size: 6}}>
                                <Input type="text" value={this.state.lastName}  onChange={this.handleLastNameChange} />
                            </Col>
                        </Row>
                    </Col>
                </Row>


                <Row>
                    <Col lg={{size: 6}} md={{size: 6}} sm={{size: 12}} xs={{size: 12}}>
                        <Row>
                            <Col lg={{size: 6}} md={{size: 6}} sm={{size: 6}} xs={{size: 6}}>
                            </Col>
                            <Col lg={{size: 6}} md={{size: 6}} sm={{size: 6}} xs={{size: 6}}>
                                <Button color="success" onClick={this.filter}>
                                    <Translate id="users-datatable.filter"/>
                                </Button>
                            </Col>
                        </Row>
                    </Col>
                    <Col lg={{size: 6}} md={{size: 6}} sm={{size: 12}} xs={{size: 12}}>
                    </Col>
                </Row>

                <DataTable headerOptions={this.state.headerOptions} data={this.state.data}
                           updateParent={this.handleRowClick}/>
                <PaginationCustom totalPages={this.state.totalPages}
                                  currentPage={this.state.currentPage} updateParent={this.handlePageClick} />
                {this.state.loading ? <LoaderFullWindow/> : null}
            </div>
        );
    }
}

export default ProfilesDataTable;